<template>
  <q-form ref="technicianData">
    <section class="q-px-md flex column">
      <div class="col-12 row title-page-form">Dados do técnico</div>
      <div class="group-input col-12 row q-mt-lg">
        <label for="number_phone">Telefone (DDD + número)</label>
        <q-input
          id="number_phone"
          class="col-12 q-mt-sm"
          bg-color="white"
          color="red-9"
          v-model="contract.numberPhone"
          dense
          outlined
          mask="(##) #####-####"
          placeholder="(##) #####-####"
          unmasked-value
          :rules="[
            (val) => (val && val.length > 0) || 'Campo Obrigatório',
            (val) => val.length > 10 || 'O número informado não parece valido.',
          ]"
          lazy-rules
          :disable="disableInputPhoneNumber"
        >
          <template v-slot:after>
            <q-btn
              round
              color="red-9"
              icon="edit"
              @click="disableInputPhoneNumberFunction"
            />
          </template>
        </q-input>
      </div>
      <div class="group-input col-12 row q-mt-lg">
        <label for="credenciada">Credenciada</label>
        <q-select
          id="accredited"
          class="col-12 q-mt-sm"
          outlined
          dense
          v-model="contract.accredited"
          color="red-9"
          use-input
          hide-selected
          fill-input
          input-debounce="0"
          :options="optionsAccredited"
          @filter="filterAccredited"
          option-value="value"
          option-label="text"
          emit-value
          bg-color="white"
          :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
          @input-value="checkIsOwnTechnician"
          lazy-rules
          :disable="disableInputAccredited"
        >
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey"> Sem resultado </q-item-section>
            </q-item>
          </template>
          <template v-slot:after>
            <q-btn
              round
              color="red-9"
              icon="edit"
              @click="disableInputAccreditedFunction"
            />
          </template>
        </q-select>
      </div>

      <div
        class="col-12 column"
      >
        <div class="group-input col-12 column q-mt-lg">
          <label for="write-off-code">É tecnico própio?</label>
          <div class="flex row justify-around">
            <q-radio
              v-model="contract.isOwnTechnician"
              disable
              keep-color
              size="lg"
              :val="true"
              label="Sim"
              color="red-6"
            />
            <q-radio
              disable
              v-model="contract.isOwnTechnician"
              keep-color
              size="lg"
              :val="false"
              label="Não"
              color="red-6"
            />
          </div>
        </div>
        <div
          class="group-input col-12 row q-mt-lg"
          v-show="contract.isOwnTechnician"
        >
          <div class="col-12">
            <label for="company_code">Código da Empresa</label>
            <q-input
              id="company_code"
              type="number"
              class="col-12 q-mt-sm"
              bg-color="white"
              color="red-9"
              v-model="contract.accreditedCode"
              dense
              outlined
              unmasked-value
              :rules="[
                (val) =>
                  (val && val.length > 0) ||
                  !contract.isOwnTechnician ||
                  'Campo Obrigatório',
              ]"
              lazy-rules
            >
            </q-input>
          </div>
        </div>
        <div
          class="group-input col-12 row q-mt-lg"
          v-show="!contract.isOwnTechnician"
        >
          <div class="col-12">
            <label for="atlas_code">Código do ATLAS</label>
            <q-input
              type="number"
              id="atlas_code"
              class="col-12 q-mt-sm"
              bg-color="white"
              color="red-9"
              v-model="contract.technicianCode"
              dense
              outlined
              unmasked-value
              :rules="[
                (val) =>
                  (val && val.length > 0) ||
                  contract.isOwnTechnician ||
                  'Campo Obrigatório',
                (val) =>
                  !val || !isNaN(Number(val)) || 'Campo deve ser numérico',
              ]"
              lazy-rules
            >
            </q-input>
          </div>
        </div>
      </div>
    </section>
  </q-form>
</template>

<script>
  import { filterListByText } from "@/helpers/filterHelper";
import { onBeforeMount, reactive, ref } from "vue";
import { useStore } from "vuex";

  export default {
    name: "technicianForm",
    props: {
      contract: Object,
      optionsItens: {
        default: {},
      },
      typeOs: Number,
    },
    setup(props) {
      let disableInputPhoneNumber = ref(true);
      let disableInputAccredited = ref(true);
      let technicianData = ref(null);
      let optionsAccredited = ref([]);

      const store = useStore();

      const userData = reactive({
        name: store.state.technicianName,
        login: store.state.technicianLogin,
      });

      function disableInputPhoneNumberFunction() {
        disableInputPhoneNumber.value = !disableInputPhoneNumber.value;
      }

      function disableInputAccreditedFunction() {
        disableInputAccredited.value = !disableInputAccredited.value;
      }

      async function validateForm() {
        return await technicianData.value.validate();
      }

      function filterAccredited(val, update) {
        update(() => {
          optionsAccredited.value = filterListByText(
            props.optionsItens.optionsAccredited,
            val,
            "text"
          );
        });
      }

      function checkIsOwnTechnician(newValue) {
        newValue == "TECNICO PROPRIO"
          ? (props.contract.isOwnTechnician = true)
          : (props.contract.isOwnTechnician = false);
      }

      onBeforeMount(() => {
        optionsAccredited.value = props.optionsItens.optionsAccredited;
      });

      return {
        technicianData,
        optionsAccredited,
        disableInputPhoneNumber,
        disableInputAccredited,
        disableInputPhoneNumberFunction,
        disableInputAccreditedFunction,
        filterAccredited,
        validateForm,
        checkIsOwnTechnician,
        userData,
      };
    },
  };
</script>

<style scoped>
  label {
    font-weight: bold;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.4);
  }
</style>
